import { isMobile } from 'react-device-detect';

import { definitions } from 'shared/types/APISchema';
import { Box } from 'shared/ui/Box';
import { FormCheckboxGroup } from 'shared/ui/FormComponents/FormCheckboxGroup';
import { FormStarsSelect } from 'shared/ui/FormComponents/FormStarsSelect';
import { FormTextArea } from 'shared/ui/FormComponents/FormTextArea';
import { Flex } from 'shared/ui/StyledComponents';

type Props = {
  item: definitions['SurveyQuestion'];
  index: number;
  key: number;
};

export const getComponentByQuestionType = ({ item, index, key }: Props) => {
  switch (item.type) {
    case 'QUESTION_ANSWER':
      return (
        <Box>
          <FormTextArea
            name={`answers[${index}].answerText`}
            customLabel={item.question}
            minHeight='200px'
            comment={item.comment}
            key={key}
          />
        </Box>
      );
    case 'QUESTION_WITH_ANSWER_OPTIONS':
      return (
        <Box>
          <FormCheckboxGroup
            align={item.isOneSelect && !isMobile ? 'horizontal' : 'vertical'}
            name={`answers[${index}].selectedAnswerOptions`}
            multiply={!item.isOneSelect}
            options={item.answerOptions}
            customLabel={item.question}
            labelGap={13}
            comment={item.comment}
            key={key}
          />
        </Box>
      );
    case 'QUESTION_MARK':
      return (
        <Flex flexDirection='column' gap={10}>
          <FormStarsSelect maxValue={5} name={`answers[${index}].mark`} comment={item.comment} label={item.question} key={key} />
        </Flex>
      );
  }
};
